// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1ZvxQ","cell":"ColumnAccessor_cell__3AAIP","firstCellAccent":"ColumnAccessor_firstCellAccent__K33Z0"};